<script>
    /*
    	ReviewCreatePanel.svelte
    */

    import { onMount } from 'svelte';
    
    // TCARE components
    import TaxonomyFieldsGroup from '../field-groups/TaxonomyFieldsGroup.svelte';
    import ServiceFieldsGroup1 from '../field-groups/ServiceFieldsGroup1.svelte';
    import ServiceFieldsGroup2 from '../field-groups/ServiceFieldsGroup2.svelte';
    import ServiceFieldsGroup3 from '../field-groups/ServiceFieldsGroup3.svelte';
    import ServiceFieldsGroup4 from '../field-groups/ServiceFieldsGroup4.svelte';
    import ServiceFieldsGroup6Stats from '../field-groups/ServiceFieldsGroup6Stats.svelte';
    import ServiceFieldsGroup5Coverage from '../field-groups/ServiceFieldsGroup5Coverage.svelte';

    export let review;                          // non-store which contains 2 stores

    $: reviewApiData = review.apiData;
    // $: leftStore = review.leftServiceObj;                   // Svelte store
    // $: leftServiceData = $leftStore.apiData;                // IMPORTANT - must use the apiData!
    $: rightStore = review.rightServiceObj;                 // Svelte store
    $: rightServiceData = $rightStore.apiData;              // IMPORTANT - must use the apiData!

    onMount(() => {
        // console.log('');
        // console.log('ReviewCreatePanel onMount: ');
        // console.log('review:');
        // console.log(review);
        // console.log('reviewApiData:');
        // console.log(reviewApiData);
        // console.log('ReviewCreatePanel onMount OK ');
        // console.log('');
    })

    const resetAllValues = () => {
        rightServiceData = JSON.parse(JSON.stringify(rightServiceData));
    }


</script>

<style>

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="review-create-panel tcare-form">
    
    <!-- CANNOT COPY VALUES OR TAXONOMIES ON THIS SCREEN - READ ONLY -->
    <!-- 8/22 - note the new bind: syntax - thanks Vito!  -->

    <TaxonomyFieldsGroup
        store={rightStore}
        leftService={null}
        rightService={rightServiceData}
        onCopyTaxonomy={null}
        isEditable={true}
        isOpen={true}
        showTcareTax1={true}
    />    
    <ServiceFieldsGroup1
        bind:store={rightStore}
        leftService={null}
        rightService={rightServiceData}
        isEditable={true}
        onCopyValue={null}
        isOpen={true}
        showDiffs={true}
    />
    <ServiceFieldsGroup2
        bind:store={rightStore}
        leftService={null}
        rightService={rightServiceData}
        isEditable={true}
        onCopyValue={null}
        isOpen={true}
        showDiffs={true}
    />
    <ServiceFieldsGroup3
        bind:store={rightStore}
        leftService={null}
        rightService={rightServiceData}
        isEditable={true}
        onCopyValue={null}
        isOpen={true}
        showDiffs={true}
    />
    <ServiceFieldsGroup4
        bind:store={rightStore}
        leftService={null}
        rightService={rightServiceData}
        isEditable={true}
        onCopyValue={null}
        isOpen={true}
        showDiffs={true}
    />
    <ServiceFieldsGroup5Coverage
        bind:store={rightStore}
        leftService={null}
        rightService={rightServiceData}
        isEditable={true}
        onCopyValue={null}
        isOpen={true}
        showDiffs={true}
    />
    <ServiceFieldsGroup6Stats
        bind:store={rightStore}
        leftService={null}
        rightService={rightServiceData}
        isEditable={false}
        onCopyValue={null}
        isOpen={false}
        showDiffs={false}
    />

    <div class="spacer-h-25"></div>

</div>
